import { useTranslation } from "react-i18next";
import { AbsenceReport } from "../admin/AbsenceReport";
import { EntityReport } from "../admin/EntityReport";
import { ReportTable } from "../admin/ReportTable";
import { VerifyAttempts } from "../admin/VerifyAttempts";
import { DutyReport } from "./DutyReport";
import { PenaltyReport } from "./PenaltyReport";
import { AttendanceReportBar } from "../attendance/AttendanceReportBar";

// محتوى التقرير المفتوح فقط — كل تقرير يجلب بياناته عند فتح تبويبه.
export const ReportSection = ({ tab, data }) => {
  const { t } = useTranslation();

  if (data.loading) return <p className="text-sm text-muted-foreground">{t("app.loading")}</p>;
  if (tab === "entities") return <EntityReport filters={data.filters} />;
  if (tab === "absences") return <AbsenceReport filters={data.filters} />;
  if (tab === "duties") return <DutyReport filters={data.filters} />;
  if (tab === "penalties") return <PenaltyReport filters={data.filters} />;
  if (tab === "verify") return <VerifyAttempts filters={data.filters} />;
  return (
    <div className="grid gap-6">
      <AttendanceReportBar filters={data.filters} />
      <ReportTable rows={data.rows} />
    </div>
  );
};
